import React from "react";
import OnlineBooking from "./components/OnlineBooking";
import Svg from "./components/svgs/svg";
import rg4js from 'raygun4js';
import { useEffect } from "react";

rg4js('apiKey', 'hrAa99XdfAp5ZB7hqahtVg');
rg4js('enableCrashReporting', true);

const onlineBookingPage = document.getElementById("online-booking");

const App = (props) => { 
  return (
    <div>
      <Svg />
      {onlineBookingPage && <OnlineBooking></OnlineBooking>}
    </div>
  );
};

export default App;
